<template>
  <img :src="icon" alt="branding" />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductBrandIcon",
  data() {
    return {
      icon: "",
    };
  },

  props: ["iconName"],

  computed: {
    ...mapGetters("catalog", ["getProductBrandIcon"]),
  },

  methods: {
    getIcon() {
      try {
        const iconUrl = this.getProductBrandIcon(this.iconName);
        const icon = iconUrl
        this.icon = icon;
      } catch (error) {
        console.log(error);
        console.log(`cannot found ${this.iconName} icon`);
      }
    },
  },

  mounted() {
    this.getIcon();
  },

  watch: {
    iconName() {
      this.getIcon();
    },
  },
};
</script>

<style></style>
